
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weinkauf/shop",
      function () {
        return require("private-next-pages/weinkauf/shop/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weinkauf/shop"])
      });
    }
  